import React, { Component, useState, useEffect } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import Footer from './components/Footer/Footer'
import List from './List'
import SideMenu from './components/SideMenu/SideMenu'
import Category from './Category'
import Content from './Content'
import Login from './components/Authentication/Login'
import Logout from './components/Authentication/Logout'
import Register from './components/Authentication/Register'
import logo from './logo.svg'
import './App.css'
import { mediaObject } from './hooks/SetBreakpoint'
import useDebouncedCallback from 'use-debounce/lib/callback'
import Search from './components/Search/Search'
import { SnackbarProvider } from 'notistack'
import { DateTime } from 'luxon'

export const MenuOpenContext = React.createContext(false)
export const MediaBreakpointContext = React.createContext({})

const App = () => {
    const [menuOpen, setMenuOpen] = useState(false)

    return (
        <MenuOpenContext.Provider value={[menuOpen, setMenuOpen]}>
          <SnackbarProvider maxSnack={3}>
          <div className="App-layout" id="App-layout">
            <div className="App-content">
              <div className="App-aside">
                <SideMenu />
              </div>
              <div className="App-main">
                <div className="App-header">
                  <div className="App-header-main">Bohemia, Moravia et Silesia Judaica</div>
                  <div className="App-header-text">Společnost pro dějiny židů v České republice</div>
                  <div className="App-header-text">Gesellschaft für Geschichte der Juden in der Čechischen Republik</div>
                </div>
                <div className="App-innerContent">
                  <Switch>
                    <Route exact path="/" render={() => (
                        <Redirect to="/content/11"/>
                    )}/>
                    <Route path={`/category`} component={Category} />
                    <Route path={`/content/:id`} component={Content} />
                    <Route path={`/register`} component={Register} />
                    <Route path={`/login`} component={Login} />
                    <Route path={`/logout`} render={(props) => <Logout timestamp={DateTime.utc().toMillis()} {...props}/>}  />
                    <Route path={`/search`} component={Search} />
                  </Switch>
                </div>
              </div>
              <span className="App-menu-button" onClick={() => setMenuOpen(!menuOpen)}>MENU<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg></span>
            </div>
            <div className="App-footer">
                <Footer/>
            </div>
          </div>
           </SnackbarProvider>
        </MenuOpenContext.Provider>
    );
}

export default App
